import React, { useRef } from 'react';
import styles from '../SaleReportPage.module.scss';

function CoverImage({ photoUrl, onUpload, onReset }) {
  const fileRef = useRef(null);

  const handleFileChange = (e) => {
    const file = e.target.files?.[0];
    if (file && onUpload) {
      onUpload(file);
    }
  };

  return (
    <div className={styles.coverImg}>
      <div
        className={styles.coverImgThumb}
        style={photoUrl ? { backgroundImage: `url(${photoUrl})` } : undefined}
      />
      <div className={styles.coverImgBody}>
        <div>
          <div className={styles.coverImgTitle}>매물 사진</div>
          <p className={styles.coverImgDesc}>
            표지에 사용할 대표 이미지입니다. 아래에서 원하는 이미지를 업로드해 주세요.
          </p>
        </div>
        <div className={styles.coverImgActions}>
          <label className={styles.coverImgUpload} onClick={() => fileRef.current?.click()}>
            이미지 업로드
          </label>
          <input
            ref={fileRef}
            type="file"
            accept="image/*"
            hidden
            onChange={handleFileChange}
          />
          {onReset && (
            <button type="button" className={styles.coverImgReset} onClick={onReset}>
              초기화
            </button>
          )}
        </div>
      </div>
    </div>
  );
}

export default CoverImage;
